import { FC } from 'react';

import {
  Badge,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from '@mui/material';

import { IcBell } from '@/assets/images';
import { useNotificationStore } from '@/store';

interface NotificationBellProps {
  collapsed?: boolean;
  showLabel?: boolean;
}

export const NotificationBell: FC<NotificationBellProps> = ({
  collapsed = false,
  showLabel = false,
}) => {
  const theme = useTheme();
  const unreadCount = useNotificationStore((state) => state.unreadCount);
  const togglePanel = useNotificationStore((state) => state.togglePanel);
  const iconColor =
    theme.palette.mode === 'dark'
      ? theme.palette.common.white
      : theme.palette.sideBar.main;

  const handleClick = () => {
    togglePanel();
  };

  if (showLabel) {
    return (
      <ListItemButton
        data-testid="notification-bell"
        onClick={handleClick}
        sx={{
          borderRadius: 2,
          minHeight: 48,
          justifyContent: collapsed ? 'center' : 'initial',
          px: 2.5,
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: 0,
            mr: collapsed ? 0 : 3,
            justifyContent: 'center',
          }}
        >
          <Badge
            badgeContent={unreadCount}
            color="error"
            max={99}
            invisible={unreadCount === 0}
          >
            <IcBell strokeWidth={1.5} color={iconColor} />
          </Badge>
        </ListItemIcon>
        {!collapsed && (
          <ListItemText
            primary="Notifications"
            primaryTypographyProps={{ fontSize: 15, fontWeight: 500 }}
          />
        )}
      </ListItemButton>
    );
  }

  // Icon-only style (for compact layouts)
  return (
    <div
      onClick={handleClick}
      data-testid="notification-bell"
      className="flex items-center p-2 justify-center rounded-full cursor-pointer transition-colors hover:bg-[#3E5A6A0F]"
    >
      <Badge
        badgeContent={unreadCount}
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '0.75rem',
            height: 18,
            minWidth: 18,
          },
        }}
      >
        <IcBell strokeWidth={1.5} color={iconColor} />
      </Badge>
    </div>
  );
};
